import { Button } from "swing-components";

import { MarkdownContent } from "~components";
import type { DownloadAnswerType } from "~onboarding/utils";

type DownloadAnswerProps = Omit<DownloadAnswerType, "type"> & {
  /**
   * The function to be called when the link is clicked
   */
  onChange: (value: string) => void;
  /**
   * Disables the ability to download the file.
   */
  isReadOnly?: boolean;
};

export function DownloadAnswer(props: DownloadAnswerProps) {
  const { markdown, download, value, onChange, isReadOnly } = props;
  const { label, url } = download;

  /*** Handler ***/
  function handleClick() {
    window.open(url, "_blank");
    onChange(value);
  }

  /*** Render ***/
  return (
    <div css={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {markdown && <MarkdownContent body={markdown} />}

      <Button
        type="secondary"
        status={isReadOnly ? "disabled" : "enabled"}
        icon={{ name: "Download", position: "left" }}
        isFluid
        onClick={handleClick}
      >
        {label}
      </Button>
    </div>
  );
}
